import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ImageService } from './image.service';
import { environment } from '../../environments/environment';
import { v4 as uuid } from 'uuid';
import { mergeMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlobStorageService {
  constructor(private _http: HttpClient, private _imageService: ImageService) { }

  private _getBlob(container: string, fileName: string) {
    const headers = new HttpHeaders({
      'x-ms-version': '2017-11-09'
    });
    const url = `${environment.azureBlob.apiUrl}/${container}/${fileName}`;
    return this._http.get(url, { responseType: 'blob', headers });
  }

  private _putBlob(container: string, fileName: string, blob: Blob) {
    const headers = new HttpHeaders({
      'x-ms-date': new Date().toUTCString(),
      'x-ms-version': '2017-11-09',
      'content-length': blob.size.toString(),
      'x-ms-blob-type': 'BlockBlob'
    });
    const url = `${environment.azureBlob.apiUrl}/${container}/${fileName}`;
    return this._http.put(url, blob, { headers }).pipe(
      map(_res => fileName)
    );
  }

  private _deleteBlob(container: string, fileName: string) {
    const headers = new HttpHeaders({
      'x-ms-version': '2017-11-09'
    });
    const url = `${environment.azureBlob.apiUrl}/${container}/${fileName}`;
    return this._http.delete(url, { headers });
  }

  getAvatar(id: string) {
    return this._getBlob('avatars', `${id}.jpg`).pipe(
        mergeMap(blob => this._imageService.getDataUri(blob, { crop: true, maxWidth: 120, maxHeight: 120 }))
    );
  }

  putAvatar(id: string, blob: Blob) {
    return this._putBlob('avatars', `${id}.jpg`, blob);
  }

  getReceipt(fileName: string) {
    return this._getBlob('receipts', fileName).pipe(
      mergeMap(blob =>
        this._imageService.parseMetaData(blob as File).pipe(
          mergeMap((metaData: any) => {
            const orientation = metaData.exif ? metaData.exif.get('Orientation') : null;
            return this._imageService.getDataUri(blob, { orientation, canvas: true });
          }),
        )
      )
    ) as Observable<string>;
    // )
    // const blob = await this._getBlob('receipts', fileName) as File;
    // const metaData = await this._imageService.parseMetaData(blob);
    // const orientation = metaData.exif ? metaData.exif.get('Orientation') : null;
    // return this._imageService.getDataUrl(blob, { orientation, canvas: true });
  }

  putReceipt(id: string | null, blob: Blob) {
    const fileName = `${id || uuid()}.jpg`;
    return this._putBlob('receipts', fileName, blob);
  }

  deleteReceipt(fileName: string) {
    return this._deleteBlob('receipts', fileName);
  }
}
